import Keycloak, { KeycloakConfig } from 'keycloak-js';
import Vue from 'vue';

/* Types. TODO: fix */
export type LoggerType = Record<
  'error' | 'info' | string,
  (...params: unknown[]) => void
>;

export type SettingsType = {
  addToPrototype?: boolean;
  addToApp?: boolean;
  app?: any;
  interval?: boolean | number;
  logger?: LoggerType;
  onError?: () => void;
  needToReloadIfNotAuth?: boolean;
  needToUpdateTokenOnFocus?: boolean;
  threshold?: number;
};

export type UpdateTokenInfo = {
  isTokenRefreshed: boolean;
  token: string | null;
  tokenParsed: any;
};

type ObjSimpleType = Record<string, unknown>;
type VueType = Vue & {
  $log: LoggerType;
  prototype: ObjSimpleType;
  mixin: (options: ObjSimpleType) => unknown;
};

/*  */
export const defaults = {
  interval: 6000,
  threshold: 70,
};

/**
 * d
 * @param {any} keycloak
 * @param {number} threshold
 * @return { isTokenRefreshed, token, tokenParsed }
 */
export async function updateToken(
  keycloak: any,
  threshold = defaults.threshold
): Promise<UpdateTokenInfo> {
  let isTokenRefreshed = false;

  try {
    isTokenRefreshed = await keycloak.updateToken(threshold);
  } catch (error: any) {
    // `error` can be undefined. Thanks to `keycloak-js`
    console.warn(
      'updateToken ERROR! Adapter message:',
      error?.message || error
    );
  }

  return {
    isTokenRefreshed,
    token: keycloak.token,
    tokenParsed: keycloak.tokenParsed,
  };
}

/*  */
export class KeyCloakPlugin {
  install(
    Vue: VueType,
    initOptions: KeycloakConfig,
    onSuccess: ({
      keycloak,
      updateToken,
    }: {
      keycloak: Keycloak;
      updateToken: any;
    }) => void = () => {
      //
    },
    {
      addToPrototype = true,
      addToApp = false,
      app,
      interval,
      logger = Vue.$log || {},
      onError = () => {
        //
      },
      threshold = defaults.threshold,
      needToReloadIfNotAuth,
      needToUpdateTokenOnFocus,
    }: SettingsType = {}
  ) {
    /*  */
    const keycloak = new Keycloak(initOptions);
    if (addToPrototype) {
      Vue.prototype.$keycloak = keycloak;
    }
    if (addToApp) {
      app.config.globalProperties.$keycloak = keycloak;
    }

    /* Define helper for token update */
    const updateTokenHelper = (v?: any) => updateToken(keycloak, v ?? threshold);

    /* Register global `watch` */
    Vue.mixin({
      watch: {
        async '$route.path'() {
          await updateTokenHelper();
        },
      },
    });

    /* Init keycloak */
    keycloak
      .init({ onLoad: initOptions?.onLoad })
      .then(auth => {
        if (!auth) {
          console.log('not auth');
          if (needToReloadIfNotAuth) return window.location.reload();
        }

        logger.info?.('Auth. Token:', keycloak.token);
        // console.log('Auth. Token:', keycloak);
        if (needToUpdateTokenOnFocus) {
          window.onfocus = updateTokenHelper;
        }
        onSuccess({ keycloak, updateToken: updateTokenHelper });

        /* Set timeout */
        if (interval) {
          setInterval(
            () => updateTokenHelper,
            typeof interval === 'boolean' ? defaults.interval : interval
          );
        }
      })
      .catch(error => {
        logger.error?.('Auth. Failed!', error.message, keycloak);
        onError();
      });
  }
}

export default new KeyCloakPlugin();
